/* eslint-disable no-undef */
import axios from '../../utils/axios';
import { BAD_REQUEST, INTERNAL_SERVER_ERROR, OK } from '../../constants/http';

const postCreateProjectDeveloper = async ({
  projectId,
  developerId,
  assignationId,
  projectCellId,
  projectRoles,
  assignedHours,
  month,
}) => {
  try {
    const response = await axios.post('/api/project-developer/create', {
      projectId,
      developerId,
      assignationId,
      projectCellId,
      projectRoles,
      assignedHours,
      month,
    });
    if (response.data.success) {
      return {
        success: true,
        status: OK.status,
        message: OK.message,
        data: response.data,
      };
    }

    return {
      success: false,
      status: BAD_REQUEST.status,
      message: response.data.data.errorMessage,
      data: {},
    };
  } catch (err) {
    const status = err.response
      ? err.response.status
      : INTERNAL_SERVER_ERROR.status;
    const message = err.response
      ? err.response.data.data.errorMessage
      : INTERNAL_SERVER_ERROR.message;

    return {
      success: false,
      status,
      message,
      data: {
        errorMessage:
          'Ha ocurrido un error. Por favor intente nuevamente en unos minutos.',
      },
    };
  }
};

const putEditProjectDeveloper = async ({ id, projectRoles, assignedHours }) => {
  try {
    const response = await axios.put('/api/project-developer/edit', {
      id,
      projectRoles,
      assignedHours,
    });
    if (response.data.success) {
      return {
        success: true,
        status: OK.status,
        message: OK.message,
        data: response.data,
      };
    }

    return {
      success: false,
      status: BAD_REQUEST.status,
      message: response.data.data.errorMessage,
      data: {},
    };
  } catch (err) {
    const status = err.response
      ? err.response.status
      : INTERNAL_SERVER_ERROR.status;
    const message = err.response
      ? err.response.data.data.errorMessage
      : INTERNAL_SERVER_ERROR.message;

    return {
      success: false,
      status,
      message,
      data: {
        errorMessage:
          'Ha ocurrido un error. Por favor intente nuevamente en unos minutos.',
      },
    };
  }
};

const deleteProjectDeveloper = async ({ id }) => {
  try {
    const { data } = await axios.delete(`/api/project-developer/${id}`);

    return {
      success: data.success,
      status: data.status,
      message: data.message,
      data,
    };
  } catch (err) {
    const status = err.response
      ? err.response.status
      : INTERNAL_SERVER_ERROR.status;
    const message = err.response
      ? err.response.statusText
      : INTERNAL_SERVER_ERROR.message;
    return {
      success: false,
      status,
      message,
      data: {
        errorMessage:
          'Ha ocurrido un error. Por favor intente nuevamente en unos minutos.',
      },
    };
  }
};

const getProjectDevelopersPerPage = async ({
  limit,
  page,
  searchProject,
  searchClient,
  searchDeveloper,
  searchStartMonth,
  searchEndMonth,
}) => {
  try {
    const { data } = await axios.get(
      `/api/project-developers?page=${page}&limit=${limit}&searchProject=${searchProject}&searchClient=${searchClient}&searchDeveloper=${searchDeveloper}&searchStartMonth=${searchStartMonth}&searchEndMonth=${searchEndMonth}`,
    );

    return {
      success: data.success,
      status: data.status,
      message: data.message,
      data,
    };
  } catch (err) {
    const status = err.response
      ? err.response.status
      : INTERNAL_SERVER_ERROR.status;
    const message = err.response
      ? err.response.statusText
      : INTERNAL_SERVER_ERROR.message;
    return {
      success: false,
      status,
      message,
      data: {
        errorMessage:
          'Ha ocurrido un error. Por favor intente nuevamente en unos minutos.',
      },
    };
  }
};

export default {
  postCreateProjectDeveloper,
  putEditProjectDeveloper,
  deleteProjectDeveloper,
  getProjectDevelopersPerPage,
};
